(ns app.front.ui.drawer
  (:require [core.front.carbon :as cc]
            [core.front.icons :as i]))

(defn view [{:keys [tr title close-fn full-height?]} content]
  [:div.fixed.top-0.right-0.bottom-0.w-full.flex.z-40
   ;; when drawer is used inside the main content add margin for header banner
   (when-not full-height?
     {:class "mt-20"})
   [:div.absolute.top-0.left-0.w-full.h-full.bg-ui-night-sky-100.opacity-25
    {:on-click close-fn}]
   [:div.absolute.top-0.right-0.h-full.flex.flex-col.bg-white.shadow-xl.animation-appear-slide-left.w-full.max-w-xl
    [:div.flex.flex-row.pl-4.pt-4.items-center.justify-between
     [:h4 title]
     (cc/button {:class-name       "w-auto justify-start"
                 :size             :small
                 :kind             :ghost
                 :icon             i/remove
                 :icon-description ""
                 :on-click         close-fn}
                (tr [:close]))]
    content]])
